import React, { useState } from 'react';
import { BsCheck2Circle } from 'react-icons/bs';
import placeholder from '../../../assets/images/placeholder.png';

type selectibleTopicType = {
	id: string;
	image: any;
	name: string;

	addedTopics: any[];
	setAddedTopics: (item: any) => void;
};

export function SelectibleTopicCard(props: selectibleTopicType) {
	const [isSelected, setSelected] = useState(false);
	const [random, setRandom] = useState(Math.floor(Math.random() * 101));

	const updateSelected = () => {
		if (!isSelected) props.setAddedTopics([...props.addedTopics, props.id]);
		else {
			props.setAddedTopics(
				props.addedTopics.filter((item) => item._id !== props.id)
			);
		}
		setSelected(!isSelected);
	};

	return (
		<div
			className="carousel-item flex flex-col"
			onClick={() => updateSelected()}
		>
			<div className="relative p-2 justify-center content-center mx-3 rounded-xl">
				<img
					src={
						props.image.url_low_res != null
							? props.image.url_low_res
							: placeholder
					}
					className="rounded-box object-cover h-44 w-64"
				/>

				<div
					className={
						isSelected
							? 'absolute inset-0 m-2 bg-gradient-to-t rounded-lg from-black/75 opacity-100 text-center transition-colors duration-500'
							: 'absolute inset-0 m-2 bg-gradient-to-t rounded-lg from-black/75 opacity-0 hover:opacity-100 transition-all duration-500 text-center'
					}
				></div>
				{isSelected ? (
					<BsCheck2Circle
						size="120"
						className="absolute h-[50%] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-gray-100 dark:shadow-lg dark:text-primary text-center transition-all duration-500 opacity-100"
					/>
				) : (
					<BsCheck2Circle
						size="120"
						className="absolute h-[50%] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-gray-100 dark:shadow-lg mx-2 dark:text-primary text-center transition-all duration-500 opacity-0 scale-0"
					/>
				)}
			</div>

			<h3 className="text-gray-600 dark:text-gray-200 text-lg mt-2 font-semibold">
				{props.name}
			</h3>
		</div>
	);
}
